<template>
    <div :class="{'active': open}" class="calendar popup-calendar">
        <span @click.prevent="emitCloseEvent" class="delete"><i class="fas fa-times-circle"></i></span>
        <calendar-body :employee="employee" v-model="selected"></calendar-body>
        <footer class="calendar-footer">
            <button @click.prevent="book" class="button is-small"
                    :class="{ 'is-dark': ! selected, 'is-primary': selected }"
                    :disabled="! selected" v-text="lang('Prenota Assistenza')"></button>
        </footer>
    </div>
</template>
<script>
    import Barba from 'barba.js'

    export default {
        props: {
            open: {
                type: Boolean,
                required: true
            },
            employee: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                selected: false
            }
        },
        methods: {
            emitCloseEvent() {
                this.$emit('closing');
            },
            book() {
                if( ! this.selected ) return false

                Barba.Pjax.goTo('/assistenza/prenota/'+this.employee.id+'?date='+this.selected.unix())
            }
        }
    }
</script>